import { render } from "./EnProceso.vue?vue&type=template&id=0e94206a&scoped=true"
import script from "./EnProceso.vue?vue&type=script&lang=js"
export * from "./EnProceso.vue?vue&type=script&lang=js"

import "./EnProceso.vue?vue&type=style&index=0&id=0e94206a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e94206a"]])

export default __exports__